type DebounceFunction = <T extends (...args: any[]) => void>(
  func: T,
  delay: number
) => (...args: Parameters<T>) => void;

export const debounce: DebounceFunction = (func, delay) => {
  let timeout: ReturnType<typeof setTimeout>;

  return function (this: unknown, ...args: any[]) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), delay);
  };
};